import { Link } from "react-router-dom";
import { ChevronRight, Zap } from "lucide-react";
import { formatNumber } from "@/lib/format";

export function PlanCard({ me }) {
  const credits = me?.credits;
  const allocation = credits?.allocation || 0;
  const used = Math.max(allocation - (credits?.balance ?? 0), 0);
  const pct = allocation ? Math.min(100, (used / allocation) * 100) : 0;
  return (
    <Link
      to="/plan"
      data-testid="plan-usage-sidebar-card"
      className="block rounded-xl border border-white/[0.08] bg-ink-850 p-3 transition-colors hover:border-white/[0.15] hover:bg-ink-800"
    >
      <div className="flex items-center gap-2.5">
        <span className="flex h-7 w-7 items-center justify-center rounded-full border border-white/10">
          <Zap className="h-3.5 w-3.5 text-zinc-300" strokeWidth={1.7} />
        </span>
        <div className="min-w-0 flex-1">
          <div className="text-[13px] font-medium text-zinc-100" data-testid="sidebar-plan-name">
            {me ? `${me.plan?.name} plan` : "Plan"}
          </div>
          <div className="text-[11.5px] text-zinc-500" data-testid="sidebar-credits-text">
            {me ? `${formatNumber(used)} / ${formatNumber(allocation)} credits used` : "Loading credits…"}
          </div>
        </div>
        <ChevronRight className="h-4 w-4 text-zinc-600" />
      </div>
      <div className="mt-2.5 h-1 overflow-hidden rounded-full bg-white/[0.07]" data-testid="sidebar-credits-progress">
        <div className="h-full rounded-full bg-white/80 transition-[width] duration-500" style={{ width: `${pct}%` }} />
      </div>
    </Link>
  );
}
